import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { FindHttpError } from '../error/find-http-error';
import { HttpError } from '../error/http-error';
import { SaveHttpError } from '../error/save-http-error';
import { UpdateHttpError } from '../error/update-http-error';
import { HttpService } from './http.service';
import { Branch } from '../model/branch';
import { NgRedux } from '@angular-redux/store';
import { ArgosState } from '../../core/argos-state';
import { PageInfo } from '../model/page-info';

@Injectable()
export class BranchService {
  public static BRANCH_END_POINT = '/branch';

  private SAVE = `${BranchService.BRANCH_END_POINT}/save`;
  private UPDATE = `${BranchService.BRANCH_END_POINT}/update`;
  private FIND_BY_ID = `${BranchService.BRANCH_END_POINT}/findById/`;
  private FIND_BY_NAME = `${BranchService.BRANCH_END_POINT}/findByName/`;
  private FIND_BY_FILTER = `${BranchService.BRANCH_END_POINT}/findByFilter/`;
  private FIND_PAGED_BRANCH = `${BranchService.BRANCH_END_POINT}/findList/`;
  private FIND_PAGE_INFO = `${BranchService.BRANCH_END_POINT}/findPageInfo/`;

  save$: Observable<Branch>;
  update$: Observable<Branch>;
  find$: Observable<any>;
  pageInfo$: Observable<PageInfo>;
  error$: Observable<HttpError>;

  private saveSubject: Subject<Branch>;
  private updateSubject: Subject<Branch>;
  private findSubject: Subject<Branch | Array<Branch>>;
  private pageInfoSubject: Subject<PageInfo>;
  private errorSubject: Subject<HttpError>;

  constructor(private _httpService: HttpService,
              private _ngRedux: NgRedux<ArgosState>) {
    this.saveSubject = new Subject();
    this.save$ = this.saveSubject.asObservable();
    this.updateSubject = new Subject();
    this.update$ = this.updateSubject.asObservable();
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.pageInfoSubject = new Subject();
    this.pageInfo$ = this.pageInfoSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  save(branch: Branch) {
    this._httpService.post(this.SAVE, branch, Branch, SaveHttpError)
      .subscribe(
        _branch => this.saveSubject.next(_branch),
        error => this.errorSubject.next(error)
      );
  }

  update(branch: Branch) {
    this._httpService.put(this.UPDATE, branch, Branch, UpdateHttpError)
      .subscribe(
        _branch => this.updateSubject.next(_branch),
        error => this.errorSubject.next(error)
      );
  }

  findByName(name: string) {
    this.findByFilter({ name: name }, 0, 30);
  }

  findById(id: number) {
    this._httpService.get(`${this.FIND_BY_ID}${id}`, Branch, FindHttpError)
      .subscribe(
        branch => this.findSubject.next(branch),
        error => this.errorSubject.next(error)
      );
  }

  findBranches(pageNumber?: number, pageSize?: number) {
    this._ngRedux.select('branchFilter')
      .subscribe(filter => {
        this.findByFilter(filter, pageNumber, pageSize);
        this.findPageInfo(filter, pageSize);
      });
  }

  findByPage(pageNumber, pageSize) {
    this._httpService.get(`${this.FIND_PAGED_BRANCH}${pageNumber}/${pageSize}`, Array, FindHttpError)
      .subscribe(
        branches => this.findSubject.next(branches),
        error => this.errorSubject.next(error)
      );
  }

  private findPageInfo(filter, pageSize) {
    this._httpService.post(`${this.FIND_PAGE_INFO}?pageSize=${pageSize}`, filter, PageInfo, FindHttpError)
      .subscribe(
        pageInfo => this.pageInfoSubject.next(pageInfo),
        error => this.errorSubject.next(error)
      );
  }

  private findByFilter(filter, pageNumber, pageSize) {
    this._httpService.post(`${this.FIND_BY_FILTER}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
                            filter, Array, FindHttpError)
      .subscribe(
        branches => this.findSubject.next(branches),
        error => this.errorSubject.next(error)
      );
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/branch.service.ts